import { motion, useScroll } from "framer-motion";
import { useEffect, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { AXIOM } from "@/constants/testIds";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const { scrollYProgress } = useScroll();
  const navigate = useNavigate();
  const location = useLocation();
  const onHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goToSection = (id) => {
    if (onHome) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate(`/#${id}`);
    }
  };

  const onLogo = (e) => {
    e.preventDefault();
    if (onHome) window.scrollTo({ top: 0, behavior: "smooth" });
    else navigate("/");
  };

  const links = [
    { id: "services", label: "Services", testId: AXIOM.nav.linkServices, kind: "scroll" },
    { id: "/about", label: "About", testId: AXIOM.nav.linkAbout, kind: "route" },
  ];

  return (
    <>
      <motion.div
        style={{ scaleX: scrollYProgress }}
        className="fixed top-0 left-0 right-0 h-[2px] bg-forge origin-left z-[70]"
      />
      <motion.nav
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.7, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
        className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
          scrolled ? "backdrop-blur-md bg-white/85 border-b border-rule" : "bg-transparent"
        }`}
      >
        <div className="max-w-[1200px] mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
          <a
            href="/"
            data-testid={AXIOM.nav.logo}
            onClick={onLogo}
            className="flex items-center gap-2.5 group"
          >
            <img
              src="https://customer-assets-rejwkqb3.emergentagent.net/job_engineer-axiom/artifacts/h00nh5nc_ChatGPT%20Image%20Jul%2014%2C%202026%2C%2005_38_12%20PM.png"
              alt="AxiomForge"
              className="h-7 w-auto"
            />
            <span className="wordmark text-[18px] leading-none">
              <span className="text-ink">Axiom</span><span className="text-forge">Forge</span>
            </span>
          </a>
          <div className="hidden md:flex items-center gap-8">
            {links.map((l) =>
              l.kind === "route" ? (
                <Link
                  key={l.id}
                  to={l.id}
                  data-testid={l.testId}
                  className={`nav-underline font-sans text-[14px] font-medium text-ink hover:text-forge transition-colors ${
                    location.pathname === l.id ? "active text-forge" : ""
                  }`}
                >
                  {l.label}
                </Link>
              ) : (
                <button
                  key={l.id}
                  onClick={() => goToSection(l.id)}
                  data-testid={l.testId}
                  className="nav-underline font-sans text-[14px] font-medium text-ink hover:text-forge transition-colors"
                >
                  {l.label}
                </button>
              )
            )}
          </div>
          <button
            onClick={() => goToSection("contact")}
            data-testid={AXIOM.nav.contactBtn}
            className="btn-forge !py-2 !px-4 text-[13px]"
          >
            Start a project
          </button>
        </div>
      </motion.nav>
    </>
  );
}
